import { EnableAddonInputSchema } from '@etiquetachef/types';

/**
 * Valida o motivo de pausar/retomar a venda de um add-on, para a tela saber
 * se o botão de confirmação pode ser habilitado.
 *
 * Origem: #710 — 2026-09-29 18:38 +0200 (botão "Retomar venda" habilitado com
 * motivo inválido).
 *
 * Por quê: os diálogos só checavam o mínimo no clique e mostravam o erro num
 * toast; acima de 500 caracteres o `callable()` recusava no `input.parse` e o
 * usuário via o genérico "Erro ao retomar a venda.". Derivar do schema — e
 * não redigitar 10/500 — mantém a tela e o callable com a mesma régua.
 *
 * Contrato: `reasonProblem` devolve `'short'` (menos de 10 após `trim`),
 * `'long'` (mais de 500) ou `null` (válido). Pura, não lança.
 *
 * Usado por: `EnableAddonDialog` e `DisableAddonDialog` (`apps/admin`, tela
 * Add-ons). Os dois schemas (`EnableAddonInputSchema`/`DisableAddonInputSchema`
 * em `packages/types/src/schemas.ts`) têm o mesmo `reason`; se divergirem,
 * este helper passa a receber o schema por parâmetro.
 *
 * Issues: #679 (épico da venda assistida), #710 (pausar/retomar venda).
 */
export type AddonReasonProblem = 'short' | 'long';

const REASON_SCHEMA = EnableAddonInputSchema.shape.reason;

/** Classifica o motivo pelo schema do callable — ver doc do módulo acima. */
export function reasonProblem(reason: string): AddonReasonProblem | null {
  const parsed = REASON_SCHEMA.safeParse(reason);
  if (parsed.success) return null;
  return parsed.error.issues.some((i) => i.code === 'too_big') ? 'long' : 'short';
}
